import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAtQcnWBTQAywSTKeWhoiAzHu_s2xQJ7FI",
  authDomain: "villa-business.firebaseapp.com",
  projectId: "villa-business",
  storageBucket: "villa-business.firebasestorage.app",
  messagingSenderId: "95968879062",
  appId: "1:95968879062:web:8c5f07c2cee3b77505c477",
  measurementId: "G-CFWXJTXZ2Y"
};

const app = initializeApp(firebaseConfig);
// export const db = getFirestore(app);
const db = getFirestore(app);
const auth = getAuth(app);
export { db, auth };